import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../../../commonDesign/Button'

async function copyToClipboard (value) {
  const text = typeof value === 'string' ? value : JSON.stringify(value, null, 2)
  if (!navigator.clipboard?.writeText) return false
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}

export default function CopyButton ({ value, label = 'copy' }) {
  const [copied, setCopied] = useState(false)
  const resetTimerRef = useRef(null)

  useEffect(() => () => {
    if (resetTimerRef.current) clearTimeout(resetTimerRef.current)
  }, [])

  const handleClick = async (e) => {
    e.stopPropagation()
    const ok = await copyToClipboard(value)
    if (!ok) return
    setCopied(true)
    if (resetTimerRef.current) clearTimeout(resetTimerRef.current)
    resetTimerRef.current = setTimeout(() => setCopied(false), 1500)
  }

  return (
    <SydButton variant='outline' size='xs' onClick={handleClick}>
      {copied ? 'copied' : label}
    </SydButton>
  )
}

CopyButton.propTypes = {
  value: PropTypes.any,
  label: PropTypes.string
}
